import type { CostCenterFormValues } from './types/costCenter';

export const MAX_COST_CENTER_NAME_LENGTH = 100;
export const MAX_COST_CENTER_DESCRIPTION_LENGTH = 500;

export const createEmptyCostCenterFormValues = (): CostCenterFormValues => ({
  name: '',
  description: '',
  creditBalance: 0,
  unpaidCreditLimit: 0,
});
